import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API, authHeaders } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';

const CHART_HEIGHT = 260;
const BAR_WIDTH = 18;
const BAR_GAP = 8;

export default function QuizStats() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [tooltip, setTooltip] = useState(null);

  const showTooltip = (e, q) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({ q, left: rect.left + rect.width / 2, top: rect.top });
  };
  const hideTooltip = () => setTooltip(null);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/admin/quiz-questions`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  if (!items) return <Layout><div style={ui.empty}>Загрузка…</div></Layout>;

  const maxCount = Math.max(1, ...items.map(q => q.answer_count));
  const totalAnswers = items.reduce((sum, q) => sum + q.answer_count, 0);

  return (
    <Layout>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <h1 style={{ ...ui.title, margin: 0 }}>Статистика по вопросам</h1>
        <button style={ui.btnSecondary} onClick={() => navigate('/quiz-questions')}>← Вопросы «Открытым Текстом»</button>
      </div>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Порядок столбцов соответствует текущему порядку вопросов в таблице — если он изменится
        или вопросы добавятся/скроются, график перестроится сам при следующем открытии страницы.
        Наведите на столбец или номер, чтобы увидеть текст вопроса.
      </p>

      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <div style={{ ...ui.card, margin: 0, flex: 1 }}>
          <div style={{ fontSize: 12, color: colors.textMuted }}>Вопросов</div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{items.length}</div>
        </div>
        <div style={{ ...ui.card, margin: 0, flex: 1 }}>
          <div style={{ fontSize: 12, color: colors.textMuted }}>Ответов всего</div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{totalAnswers}</div>
        </div>
      </div>

      <div style={ui.card}>
        {items.length === 0 ? (
          <div style={ui.empty}>Вопросов пока нет</div>
        ) : (
          <div style={{ overflowX: 'auto', paddingBottom: 8 }}>
            <div style={{
              display: 'flex', alignItems: 'flex-end', gap: BAR_GAP, height: CHART_HEIGHT,
              borderBottom: `1px solid ${colors.border}`, paddingBottom: 4, width: 'fit-content',
            }}>
              {items.map((q, i) => {
                const barHeight = Math.max(2, Math.round((q.answer_count / maxCount) * (CHART_HEIGHT - 24)));
                return (
                  <div
                    key={q.id}
                    style={{ width: BAR_WIDTH, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%', cursor: 'default' }}
                    onMouseEnter={e => showTooltip(e, q)}
                    onMouseLeave={hideTooltip}
                  >
                    <div style={{
                      width: BAR_WIDTH, height: barHeight, borderRadius: '3px 3px 0 0',
                      background: q.is_active ? colors.accent : colors.textMuted,
                      opacity: q.is_active ? 1 : 0.5,
                    }} />
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: BAR_GAP, width: 'fit-content', marginTop: 6 }}>
              {items.map((q, i) => (
                <div
                  key={q.id}
                  style={{ width: BAR_WIDTH, flexShrink: 0, textAlign: 'center', fontSize: 10, color: colors.textMuted, cursor: 'default' }}
                  onMouseEnter={e => showTooltip(e, q)}
                  onMouseLeave={hideTooltip}
                >
                  {i + 1}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {tooltip && (
        <div style={{
          position: 'fixed', left: tooltip.left, top: tooltip.top - 8, transform: 'translate(-50%, -100%)',
          background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8,
          padding: '10px 12px', width: 220, zIndex: 1000, boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
          pointerEvents: 'none',
        }}>
          <div style={{ fontSize: 11, color: colors.accent, marginBottom: 4 }}>
            {tooltip.q.topic}{!tooltip.q.is_active && ' · скрыт'}
          </div>
          <div style={{ fontSize: 13, lineHeight: 1.4 }}>{tooltip.q.text}</div>
          <div style={{ fontSize: 11, color: colors.textMuted, marginTop: 6 }}>Ответов: {tooltip.q.answer_count}</div>
        </div>
      )}
    </Layout>
  );
}
